var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.49967,
    cy: 8.00016,
    r: 6,
    stroke: "#1E2D66",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3855 6.11426L6.61426 9.88549M10.3855 9.8855L6.61426 6.11426",
    stroke: "#1E2D66",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputRemove);
export default __webpack_public_path__ + "static/media/Input_Remove.0786e92e0b6ea690d6c1543004663e76.svg";
export { ForwardRef as ReactComponent };